import {
    getAllTickets,
    updateATicket,
    createATicket,
} from '../../services/tickets'
import { errorHandler } from '../../utils/errorHandler'
import { notification } from '../notification/notificationActions'
import { ticketTypes } from './ticketTypes'

export const getAllTicketsAction = (body, role) => async dispatch => {
    dispatch({
        type: ticketTypes.GET_ALL_TICKETS_START,
    })
    try {
        const { data } = await getAllTickets(body, role, dispatch)
        dispatch({
            type: ticketTypes.GET_ALL_TICKETS_SUCCESS,
            payload: data?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(dispatch, ticketTypes.GET_ALL_TICKETS_FAILED, error)
    }
    dispatch({
        type: ticketTypes.GET_ALL_TICKETS_END,
    })
}

export const addMessageToTicketAction = (id, body, resetState) => async (
    dispatch,
    getState
) => {
    const { allTickets } = getState().tickets
    const { user } = getState().user

    // let filteredTicket = allTickets?.filter(ticket=>ticket.id!==id);
    let updatedTicketIndex = allTickets?.findIndex(item => item?.id === id)

    dispatch({
        type: ticketTypes.ADD_MESSAGE_TO_TICKET_START,
    })
    try {
        const { data } = await updateATicket(id, body, user.roles[0].name)
        allTickets[updatedTicketIndex].conversation = data?.data?.conversation
        allTickets[updatedTicketIndex].status = data?.data?.status
        // filteredTicket.push(data)
        // ------------- add message to all tickets -------
        dispatch({
            type: ticketTypes.ADD_MESSAGE_TO_TICKET_SUCCESS,
            payload: [...allTickets],
        })
        dispatch(
            notification({
                message: 'پاسخ با موفقیت ارسال شد',
                variant: 'success',
            })
        )
        resetState()
    } catch (error) {
        errorHandler(
            dispatch,
            ticketTypes.ADD_MESSAGE_TO_TICKET_FAILED,
            error,
            allTickets
        )
    }
    dispatch({
        type: ticketTypes.ADD_MESSAGE_TO_TICKET_END,
    })
}

export const createNewTicketAction = (body, resetState, closeModal) => async (
    dispatch,
    getState
) => {
    const { allTickets } = getState().tickets

    // let filteredTicket = allTickets?.filter(ticket=>ticket.id!==id);

    dispatch({
        type: ticketTypes.CREATE_A_TICKET_START,
    })
    try {
        const { data } = await createATicket(body)
        allTickets.unshift(data?.data)
        // filteredTicket.push(data)
        // ------------- add message to all tickets -------
        dispatch({
            type: ticketTypes.CREATE_A_TICKET_SUCCESS,
            payload: [...allTickets],
        })
        dispatch(
            notification({
                message: 'تیکت با موفقیت ارسال شد',
                variant: 'success',
            })
        )
        resetState()
        closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            ticketTypes.CREATE_A_TICKET_FAILED,
            error,
            allTickets
        )
    }
    dispatch({
        type: ticketTypes.CREATE_A_TICKET_END,
    })
}

export const updateATicketAction = (id, body) => async (dispatch, getState) => {
    const { allTickets } = getState().tickets
    let updatedTicketIndex = allTickets?.findIndex(item => item?.id === id)
    dispatch({
        type: ticketTypes.UPDATE_TICKET_START,
    })
    try {
        const data = await updateATicket(id, body)
        if (data?.code === 200) {
            allTickets[updatedTicketIndex].status = body?.status
            dispatch({
                type: ticketTypes.UPDATE_TICKET_SUCCESS,
                payload: [...allTickets],
            })
            dispatch(
                notification({
                    message: 'تغییر وضعیت تیکت با موفقیت انجام شد',
                    variant: 'success',
                })
            )
        }
    } catch (error) {
        errorHandler(
            dispatch,
            ticketTypes.UPDATE_TICKET_FAILED,
            error,
            allTickets
        )
    }
    dispatch({
        type: ticketTypes.UPDATE_TICKET_END,
    })
}
